<template>
  <div class="ec-health scrollable">
    <div class="w-full h-full m-auto flex !flex-row justify-center align-center">
      <iframe width="100%" height="100%" :src="'https://zorgenwelzijn.datascouts.eu/ecosystem-maps/5/embed?apiKey=ds_live_hWtlEHdZ4MGNBRmLTIpE&language=' + language"
              frameborder="0"
              allowfullscreen></iframe>
    </div>

    <!--    <SimplifiedFooter :with-margin="true"/>-->
  </div>
</template>

<script lang="ts">
  import SimplifiedFooter from '../SimplifiedFooter/SimplifiedFooter.vue'
  import { defineComponent } from "vue";
  import CarouselMixin from '@/util/CarouselMixin'
  import BasicHero from '@/components/BasicHero/BasicHero.vue'
  import TranslationsMixin from '@/util/TranslationsMixin'
  import BasicSimplifiedHero from '@/components/Simplified/BasicSimplifiedHero.vue'
  import UiMixin from '@/util/UiMixin'

  export default defineComponent({
    data() {
      return {}
    },
    mixins: [CarouselMixin, TranslationsMixin, UiMixin],
    computed: {
      language() {
        return this.$store.getters.activeLocale
      },
    },
    methods: {},
    mounted() {
    },
    components: {
      BasicSimplifiedHero,
      BasicHero,
      SimplifiedFooter,
    },
  })
</script>


<style lang="scss" scoped>
</style>
